import { render, staticRenderFns } from "./ChatTrainLLMPrompt.vue?vue&type=template&id=815009e8&scoped=true"
import script from "./ChatTrainLLMPrompt.vue?vue&type=script&lang=js"
export * from "./ChatTrainLLMPrompt.vue?vue&type=script&lang=js"
import style0 from "./ChatTrainLLMPrompt.vue?vue&type=style&index=0&id=815009e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "815009e8",
  null
  
)

export default component.exports